import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {IconMenu, MenuItem, IconButton, FlatButton, Dialog} from "material-ui";
import {grey400} from 'material-ui/styles/colors';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import AdminService from '../../../services/admin';
import {ADMIN} from '../../../services/admin';
import {fetchApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './ReportSubjectPage.css';
import ReportSubjectFull from "../../../components/report/ReportSubjectFull/ReportSubjectFull";
import {
    fetchReportSubject,
    deleteReportSubject,
    postReportSubjectPicture,
    deleteReportSubjectPicture
} from "../../../store/reportsubjects/actions";
import {EDIT_REPORTSUBJECT_PAGE, SETTING_PAGE} from "../../../constants/routes";

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class ReportSubjectPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        currentSubject: PropTypes.object
    };

    state = {
        subjectToRemove: null,
        openRemoveSubject: false,
        openRemoveSubjectPicture: false
    };

    static defaultProps = {};

    componentWillMount() {
        this.fetchApplication();
        this.fetchSubject();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.app && !nextProps.currentSubject) {
            this.fetchSubject(nextProps.app.id);
        }
    }

    // Fetch

    fetchSubject(appId = null, subjectId = null) {
        if (this.props.match) {
            let app = appId || this.props.match.params.appId;
            let subject = subjectId || this.props.match.params.reportsubjectId;
            if (app && subject) {
                this.props.fetchReportSubject(app, subject)
            }
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    // handle

    handleDeleteSubject = () => {
        this.setState({
            openRemoveSubject: true,
            subjectToRemove: this.props.currentSubject
        });
    };

    handleCloseSubject = () => {
        this.setState({
            openRemoveSubject: false,
            subjectToRemove: null
        });
    };

    deleteSubjectPicture = () => {
        this.props.deleteReportSubjectPicture(this.props.app.id, this.props.currentSubject.id);
        this.setState({
            openRemoveSubjectPicture: false
        });
    };

    deleteSubject = () => {
        this.props.deleteReportSubject(this.props.app.id, this.props.currentSubject.id);
        this.props.history.push(SETTING_PAGE.replace(':appId', this.props.app.id));
    };

    renderDeleteSubjectDialog(currentSubject) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseSubject}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteSubject}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemoveSubject}
                    onRequestClose={this.handleCloseSubject}>
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>
                    Do you really want to remove the subject "{currentSubject.name}" ?
                </p>
                }
            </Dialog>
        );
    }

    handleDeleteSubjectPicture = () => {
        this.setState({
            openRemoveSubjectPicture: true
        });
    };

    handleCloseSubjectPicture = () => {
        this.setState({
            openRemoveSubjectPicture: false
        });
    };

    renderDeleteSubjectPictureDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseSubjectPicture}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteSubjectPicture}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemoveSubjectPicture}
                    onRequestClose={this.handleCloseSubject}>
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>
                    Do you really want to remove the picture ?
                </p>
                }
            </Dialog>
        );
    }

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.currentSubject) {
            return <Loading paper={false} />;
        } else {
            let menu;
            if (AdminService.isAuthorized(ADMIN, this.props.user)) {
                menu = (
                    <IconMenu
                        style={styles.buttons}
                        listStyle={style.list}
                        iconButtonElement={iconButtonElement}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                        <Link
                            to={EDIT_REPORTSUBJECT_PAGE.replace(':appId', this.props.app.id).replace(':reportsubjectId', this.props.currentSubject.id)}>
                            <MenuItem>
                                Edit
                            </MenuItem>
                        </Link>
                        <MenuItem onClick={this.handleDeleteSubject}>
                            Remove
                        </MenuItem>
                        {this.props.currentSubject.picture &&
                        <MenuItem onClick={this.handleDeleteSubjectPicture}>
                            Remove picture
                        </MenuItem>}
                    </IconMenu>
                );
            } else {
                menu = null;
            }
            return (
                <div>
                    {this.state.openRemoveSubject && this.renderDeleteSubjectDialog(this.state.subjectToRemove)}
                    {this.state.openRemoveSubjectPicture && this.renderDeleteSubjectPictureDialog()}
                    <h3 style={style.navigation}>Subject / Detail - {this.props.app.name}</h3>
                    {menu}
                    <ReportSubjectFull
                        app={this.props.app}
                        subject={this.props.currentSubject}
                        postPicture={this.props.postReportSubjectPicture}
                        deletePicture={this.props.deleteReportSubjectPicture}
                    />
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending || state.reportsubjects.pending,
        error: state.apps.error,
        currentSubject: state.reportsubjects.currentSubject,
        app: state.apps.currentApplication,
        sending: state.reportsubjects.sending,
        user: state.auth.content
    };
}

export default connect(mapStateToProps, {
    fetchApp,
    fetchReportSubject,
    deleteReportSubject,
    postReportSubjectPicture,
    deleteReportSubjectPicture
})(ReportSubjectPage);



// WEBPACK FOOTER //
// src/containers/reportsubjects/ReportSubjectPage/ReportSubjectPage.js